export enum EnumCharges {
    driver = 'Motorista',
    operator = 'Operador',
    others = 'Outros'
}
